import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import OrderDetailAtom from '../../@atoms/to_content/order_detail/order_detail.atom'
import SkeletonAtom from '../../@atoms/to_layout/skeleton/skeleton.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import {RootState} from '../../store_redux'
import {fetchOrderHeaderDetails} from '../../store_redux/reducer/order_details.reducer'
import utils from '../../utils'
import OrderDetailsErrorComponent from './order_details_error.component'

const OrderDetailsComponent: React.FC = function () {
  const rootState = useSelector((state: RootState) => state)
  const dispatch = useDispatch()
  const {labels, orderDetails} = rootState

  const isLabelEmpty = utils.isObjectEmpty(labels)
  const headerDetails = orderDetails.header.data

  useEffect(() => {
    dispatch(fetchOrderHeaderDetails())
    // eslint-disable-next-line
  }, [])

  if ((!headerDetails && !orderDetails.header.error) || isLabelEmpty)
    return (
      <OrderDetailAtom>
        <SkeletonAtom ap_type="order_details_skeleton" />
      </OrderDetailAtom>
    )

  const {title, orderNumber, orderedOn} = labels.myOrders.header

  const formatDate = () =>
    headerDetails?.orderedOn
      ? utils.formatDate(headerDetails.orderedOn, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      : 'N/A'

  const renderShipmentLabel = () => {
    const shipmentLabels: {[key: string]: string} = {
      delivery: labels.myOrders?.header?.deliveryShipment,
      deliveryPlural: labels.myOrders?.header.deliveryShipmentPlural,
      collection: labels.myOrders?.header.collectionShipment,
      collectionPlural: labels.myOrders?.header.collectionShipmentPlural,
      exchange: labels.myOrders?.header.exchangeShipment,
      exchangePlural: labels.myOrders.header.exchangeShipmentPlural,
    }

    const keyPlural = (): string | undefined => {
      let strVar
      if (headerDetails?.activeVisitCount) {
        strVar = headerDetails?.activeVisitCount > 1 ? 'Plural' : ''
      }
      return strVar
    }

    const visitQty = `${headerDetails?.activeVisitCount}`

    return `${shipmentLabels[
      headerDetails?.orderType
        ? `${headerDetails?.orderType.toLowerCase()}${keyPlural()}`
        : ''
    ].replace('{n}', visitQty)}`
  }

  const getError = () =>
    orderDetails.header.errorCode
      ? utils.getErrorMsg(
          labels.errors.getOrderHeaderDetails,
          orderDetails.header.errorCode,
        )
      : utils.getErrorMsg(
          labels.errors.getVisitDetails,
          orderDetails.visits.errorCode,
        )

  if (!isLabelEmpty && (orderDetails.header.error || orderDetails.visits.error))
    return (
      <OrderDetailsErrorComponent
        title={title}
        errorMsg={getError()}
        btnLabel={labels.myOrders.header.errorButton}
      />
    )

  return (
    <OrderDetailAtom>
      <TypographyAtom ahd_type="h7">{title}</TypographyAtom>
      <BoxAtom>
        <TypographyAtom ahd_type="sLabel">{orderNumber}:</TypographyAtom>
        <TypographyAtom
          ahd_type={headerDetails?.orderNumber ? 'sLink' : 'sData'}
        >
          {headerDetails?.orderNumber || 'N/A'}
        </TypographyAtom>
      </BoxAtom>
      <BoxAtom>
        <TypographyAtom ahd_type="sLabel">{orderedOn}:</TypographyAtom>
        <TypographyAtom ahd_type="sData">{formatDate()}</TypographyAtom>
      </BoxAtom>
      {headerDetails?.orderType && (
        <TypographyAtom ahd_type="sData">
          {renderShipmentLabel()}
        </TypographyAtom>
      )}
    </OrderDetailAtom>
  )
}

export default OrderDetailsComponent
